import React from 'react';

function PledgerIcon(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="89"
            height="23"
            viewBox="0 0 89 23"
            fill="none"
            {...props}
        >
            <g clipPath="url(#clip0_2_6)">
                <mask
                    id="mask0_2_6"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="89"
                    height="23"
                >
                    <path
                        d="M88.8863 0.11795H0V23H88.8863V0.11795Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask0_2_6)">
                    <mask
                        id="mask1_2_6"
                        style={{ maskType: 'luminance' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="89"
                        height="23"
                    >
                        <path d="M89 0H0V23H89V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask1_2_6)">
                        <path
                            d="M14.5016 1.06152C11.5444 1.06152 8.75783 2.77178 7.3361 5.4846C7.3361 5.4846 1.47859 15.8641 1.25112 16.2769C1.02364 16.8077 0.56869 17.2205 0 17.4564C0.056869 17.6333 0.170607 17.8102 0.227476 17.9872H0.56869C0.966773 17.9872 1.30799 17.8102 1.53546 17.4564L3.52588 14.3897H7.10863C7.96166 14.3897 8.75783 13.9179 9.15591 13.1513L13.6486 5.18973C14.5016 3.71537 15.4684 2.35896 16.6058 1.1205H14.5016V1.06152Z"
                            fill="#CFA477"
                        />
                    </g>
                    <mask
                        id="mask2_2_6"
                        style={{ maskType: 'luminance' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="89"
                        height="23"
                    >
                        <path d="M89 0H0V23H89V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask2_2_6)">
                        <path
                            d="M23.43 3.65641V10.9692C23.9987 11.0282 24.4537 11.0872 24.8518 11.0872C26.2166 11.0872 27.2971 10.7333 28.0364 9.96666C28.7757 9.25897 29.1169 8.19743 29.1169 6.84102C29.1169 5.36666 28.7757 4.18718 28.0933 3.30256C27.4109 2.41795 26.501 1.94615 25.4205 1.94615C24.7949 1.94615 24.3399 2.12307 23.9987 2.41795C23.6007 2.71282 23.43 3.12564 23.43 3.65641ZM25.0792 17.5744V17.9872H18.653V17.5744C19.7336 17.2795 20.2454 16.5128 20.2454 15.3333V3.95128C20.2454 2.77179 19.7336 2.00513 18.653 1.76923V1.35641C21.0984 1.06154 23.3732 0.884613 25.4773 0.884613C27.5815 0.884613 29.2876 1.41538 30.6524 2.41795C32.0173 3.42051 32.6428 4.71795 32.6428 6.31025C32.6428 7.60769 32.3016 8.7282 31.5623 9.67179C30.823 10.6154 29.9131 11.3231 28.8895 11.7359C27.809 12.1487 26.6716 12.3846 25.4205 12.3846C24.7949 12.3846 24.1693 12.3256 23.4869 12.1487V15.3333C23.4869 15.8641 23.6575 16.3359 23.9419 16.7487C24.1693 17.1615 24.5674 17.4564 25.0792 17.5744Z"
                            fill="#0F2135"
                        />
                    </g>
                    <mask
                        id="mask3_2_6"
                        style={{ maskType: 'luminance' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="89"
                        height="23"
                    >
                        <path d="M89 0H0V23H89V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask3_2_6)">
                        <path
                            d="M36.1687 0.11795V15.5692C36.1687 16.5718 36.5668 17.2205 37.4198 17.5744V17.9872H31.9604V17.5744C32.6997 17.2205 33.0978 16.5718 33.0978 15.5692V4.30513C33.0978 3.18462 32.6428 2.47692 31.7898 2.24103V1.82821C33.3252 1.65128 34.6901 1.06154 35.7706 0.11795H36.1687Z"
                            fill="#0F2135"
                        />
                    </g>
                    <mask
                        id="mask4_2_6"
                        style={{ maskType: 'luminance' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="89"
                        height="23"
                    >
                        <path d="M89 0H0V23H89V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask4_2_6)">
                        <path
                            d="M41.9125 7.19488C41.3438 7.19488 40.832 7.48976 40.4339 8.02053C40.0358 8.55129 39.7515 9.37694 39.6946 10.4385H43.9598C43.9598 9.43591 43.7892 8.66924 43.4479 8.0795C43.0499 7.48976 42.538 7.19488 41.9125 7.19488ZM46.9169 14.6846C46.5757 15.8051 46.007 16.6898 45.0971 17.3385C44.1872 17.9872 43.2205 18.341 42.14 18.341C40.7182 18.341 39.4671 17.8103 38.4435 16.8077C37.363 15.8051 36.8511 14.3898 36.8511 12.5616C36.8511 10.7923 37.363 9.25899 38.4435 7.96155C39.524 6.72309 40.832 6.07437 42.4812 6.07437C43.7892 6.07437 44.8697 6.54617 45.7796 7.37181C46.6326 8.25642 47.0876 9.37694 47.0876 10.7923V11.3821H39.6946C39.7515 12.9744 40.0927 14.1539 40.7751 14.9795C41.4575 15.8051 42.3674 16.218 43.5048 16.218C44.8128 16.218 45.8364 15.6282 46.6326 14.4487L46.9169 14.6846Z"
                            fill="#0F2135"
                        />
                    </g>
                    <mask
                        id="mask5_2_6"
                        style={{ maskType: 'luminance' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="89"
                        height="23"
                    >
                        <path d="M89 0H0V23H89V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask5_2_6)">
                        <path
                            d="M53.4569 16.3949C54.0824 16.3949 54.7649 16.1 55.4473 15.5103V8.9641C55.4473 8.43333 55.2767 8.02051 54.9923 7.72564C54.708 7.3718 54.253 7.25385 53.7412 7.25385C52.8313 7.25385 52.092 7.72564 51.5233 8.66923C50.9546 9.61282 50.6703 10.7333 50.6703 12.0897C50.6703 13.4462 50.8978 14.5077 51.4096 15.2744C51.8645 15.9821 52.547 16.3949 53.4569 16.3949ZM51.6939 18.341C50.5566 18.341 49.5898 17.8692 48.7367 16.8667C47.9406 15.8641 47.4856 14.6256 47.4856 13.1513C47.4856 11.2641 48.0543 9.61282 49.2486 8.25641C50.3859 6.9 51.8645 6.19231 53.6275 6.19231C54.253 6.19231 54.8217 6.31026 55.3904 6.48718V4.30513C55.3904 3.18462 54.8786 2.5359 53.9118 2.24103V1.82821C55.5042 1.65128 56.869 1.06154 57.9495 0.11795H58.3476V14.6256C58.3476 15.7462 58.7457 16.5128 59.5987 16.8077V17.2205C58.3476 17.3385 57.0965 17.7513 55.7885 18.459H55.3904V17.3974C55.3904 17.2795 55.3904 17.1026 55.3904 16.8077C55.3904 16.5718 55.3904 16.3949 55.3904 16.3359H55.3336C54.8786 16.8667 54.3099 17.3385 53.6275 17.6923C53.0588 18.1051 52.3764 18.341 51.6939 18.341Z"
                            fill="#0F2135"
                        />
                    </g>
                    <mask
                        id="mask6_2_6"
                        style={{ maskType: 'luminance' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="89"
                        height="23"
                    >
                        <path d="M89 0H0V23H89V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask6_2_6)">
                        <path
                            d="M64.0345 7.1359C62.8403 7.1359 62.2716 8.07949 62.2716 10.0256C62.2716 10.9103 62.4422 11.618 62.7265 12.1487C63.0109 12.6795 63.4658 12.9154 64.0345 12.9154C64.6032 12.9154 65.115 12.6795 65.3994 12.1487C65.7406 11.618 65.9112 10.9103 65.9112 10.0256C65.8543 8.07949 65.2287 7.1359 64.0345 7.1359ZM61.0773 20.0513C61.0773 20.641 61.4185 21.0539 62.101 21.4077C62.7834 21.7026 63.6364 21.8795 64.7738 21.8205C65.7974 21.8205 66.5936 21.6436 67.2192 21.3487C67.8447 21.0539 68.1291 20.7 68.1291 20.2282C68.1291 20.0513 68.0722 19.8744 68.0153 19.6974C67.9585 19.5205 67.7879 19.4026 67.6172 19.2846C67.4466 19.1667 67.276 19.0487 67.1054 18.9308C66.9348 18.8128 66.7073 18.7539 66.3661 18.6359C66.0249 18.518 65.7406 18.459 65.57 18.4C65.3994 18.341 65.0581 18.2821 64.6601 18.1641C64.262 18.0462 63.9208 17.9872 63.7502 17.9282C61.9303 18.2821 61.0773 18.9308 61.0773 20.0513ZM70.5744 19.0487C70.5744 20.2282 70.0057 21.1128 68.8115 21.8205C67.6172 22.5282 66.1387 22.8821 64.3757 22.8821C63.6933 22.8821 63.0677 22.8231 62.4422 22.7641C61.8166 22.6462 61.191 22.5282 60.6224 22.3513C60.0537 22.1744 59.5987 21.8795 59.2006 21.5256C58.8594 21.1718 58.6888 20.759 58.6888 20.2872C58.6888 19.6974 59.0869 19.2256 59.8262 18.7539C60.5655 18.2821 61.5891 17.9872 62.7265 17.8103C61.3048 17.3974 60.4518 16.8077 60.1105 15.9821V15.6872C61.3617 15.2154 62.3853 14.6256 63.1815 13.859C62.0441 13.6821 61.1342 13.2692 60.3949 12.5615C59.6556 11.8539 59.3144 11.0282 59.3144 10.0846C59.3144 9.02308 59.7693 8.13847 60.6792 7.3718C61.5891 6.60514 62.7265 6.25129 64.0345 6.25129C65.3994 6.25129 66.5367 6.66411 67.5035 7.43078C68.2428 6.31026 69.0958 5.72052 70.0626 5.72052C70.4038 5.72052 70.745 5.83847 70.9725 6.07437C71.2 6.31026 71.3706 6.60514 71.3706 6.95898C71.3706 7.31283 71.2569 7.6077 71.0294 7.8436C70.8019 8.07949 70.5176 8.19744 70.2332 8.19744C69.9489 8.19744 69.6645 8.07949 69.3233 7.8436C69.039 7.6077 68.7546 7.48975 68.584 7.48975C68.3565 7.48975 68.1859 7.6077 67.9585 7.78462C68.584 8.49231 68.9252 9.25898 68.9252 10.0846C68.9252 11.1462 68.4703 12.0308 67.5035 12.7974C66.5367 13.5641 65.3994 13.918 64.0914 13.918H63.9776C63.6933 14.2128 63.5796 14.4487 63.5796 14.6846C63.5796 14.9205 63.807 15.1564 64.3188 15.3333C64.8307 15.5103 65.3994 15.6872 66.0818 15.8641C66.7642 16.041 67.4466 16.218 68.1859 16.4539C68.8684 16.6898 69.4939 17.0436 69.9489 17.5154C70.347 17.8103 70.5744 18.4 70.5744 19.0487Z"
                            fill="#0F2135"
                        />
                    </g>
                    <mask
                        id="mask7_2_6"
                        style={{ maskType: 'luminance' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="89"
                        height="23"
                    >
                        <path d="M89 0H0V23H89V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask7_2_6)">
                        <path
                            d="M75.2377 7.19488C74.669 7.19488 74.1572 7.48976 73.7591 8.02053C73.361 8.55129 73.0767 9.37694 73.0198 10.4385H77.285C77.285 9.43591 77.1144 8.66924 76.7732 8.0795C76.3751 7.48976 75.8633 7.19488 75.2377 7.19488ZM80.2422 14.6846C79.901 15.8051 79.3323 16.6898 78.4224 17.3385C77.5125 17.9872 76.5457 18.341 75.4652 18.341C74.0435 18.341 72.7923 17.8103 71.7687 16.8077C70.6882 15.8051 70.1764 14.3898 70.1764 12.5616C70.1764 10.7923 70.6882 9.25899 71.7687 7.96155C72.8492 6.72309 74.1572 6.07437 75.8064 6.07437C77.1144 6.07437 78.1949 6.54617 79.1048 7.37181C79.9578 8.25642 80.4128 9.37694 80.4128 10.7923V11.3821H73.0198C73.0767 12.9744 73.4179 14.1539 74.1003 14.9795C74.7828 15.8051 75.6927 16.218 76.83 16.218C78.138 16.218 79.1617 15.6282 79.9578 14.4487L80.2422 14.6846Z"
                            fill="#0F2135"
                        />
                    </g>
                    <mask
                        id="mask8_2_6"
                        style={{ maskType: 'luminance' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="89"
                        height="23"
                    >
                        <path d="M89 0H0V23H89V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask8_2_6)">
                        <path
                            d="M84.223 7.25386C84.223 7.43078 84.1661 7.78463 84.1092 8.37437L84.223 8.43334C84.5642 7.8436 84.9623 7.25386 85.5878 6.78206C86.1565 6.31027 86.7252 6.07437 87.2939 6.07437C87.7489 6.07437 88.1469 6.25129 88.4313 6.54616C88.7725 6.90001 88.8862 7.25386 88.8862 7.78463C88.8862 8.25642 88.7725 8.61027 88.4882 8.90514C88.2038 9.20001 87.8626 9.37693 87.5214 9.37693C87.1802 9.37693 86.7821 9.20001 86.384 8.84616C85.9859 8.49232 85.6447 8.3154 85.3604 8.3154C85.076 8.3154 84.6779 8.61027 84.223 9.14104V15.5103C84.223 16.3949 84.6779 17.0436 85.531 17.5154V17.9282H79.9009V17.5154C80.754 17.1026 81.2089 16.3949 81.2089 15.5103V10.0846C81.2089 9.49488 81.0952 9.02309 80.9246 8.66924C80.6971 8.37437 80.4128 8.13847 79.9009 8.02052V7.66668C80.5834 7.54873 81.3227 7.37181 82.062 7.07693C82.8013 6.78206 83.3699 6.36924 83.8249 5.95642H84.223V7.25386Z"
                            fill="#0F2135"
                        />
                    </g>
                    <mask
                        id="mask9_2_6"
                        style={{ maskType: 'luminance' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="89"
                        height="23"
                    >
                        <path d="M89 0H0V23H89V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask9_2_6)">
                        <path
                            d="M22.0652 20.8179C22.0083 20.759 22.0083 20.7 21.9514 20.641C21.8946 20.5821 21.8377 20.5821 21.7808 20.5231C21.724 20.5231 21.6671 20.4641 21.5534 20.4641C21.4396 20.4641 21.3259 20.4641 21.2121 20.5231C21.0984 20.5821 21.0415 20.641 20.9847 20.759C20.9278 20.8769 20.8709 20.9359 20.8709 21.0538C20.8709 21.1718 20.8141 21.2897 20.8141 21.4077C20.8141 21.5256 20.8141 21.6436 20.8709 21.7615C20.8709 21.8795 20.9278 21.9974 20.9847 22.0564C21.0415 22.1744 21.0984 22.2333 21.2121 22.2923C21.3259 22.3513 21.4396 22.3513 21.5534 22.3513C21.724 22.3513 21.8946 22.2923 22.0083 22.1744C22.122 22.0564 22.1789 21.8795 22.1789 21.7026H22.7476C22.7476 21.8795 22.6907 22.0564 22.6339 22.1744C22.577 22.2923 22.4633 22.4103 22.4064 22.5282C22.2926 22.6462 22.1789 22.7051 22.0652 22.7641C21.9514 22.8231 21.7808 22.8231 21.6102 22.8231C21.3827 22.8231 21.2121 22.7641 21.0415 22.7051C20.8709 22.6462 20.7572 22.5282 20.6434 22.4103C20.5297 22.2923 20.416 22.1154 20.3591 21.9385C20.3022 21.7615 20.2454 21.5846 20.2454 21.3487C20.2454 21.1128 20.3022 20.9359 20.3591 20.759C20.416 20.5821 20.5297 20.4051 20.6434 20.2872C20.7572 20.1692 20.8709 20.0513 21.0415 19.9923C21.2121 19.9333 21.3827 19.8744 21.6102 19.8744C21.7808 19.8744 21.8946 19.8744 22.0083 19.9333C22.122 19.9923 22.2358 20.0513 22.3495 20.1103C22.4633 20.1692 22.5201 20.2872 22.6339 20.4051C22.6907 20.5231 22.7476 20.7 22.7476 20.8179H22.1789C22.122 20.9359 22.122 20.8769 22.0652 20.8179Z"
                            fill="#CFA477"
                        />
                    </g>
                    <mask
                        id="mask10_2_6"
                        style={{ maskType: 'luminance' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="89"
                        height="23"
                    >
                        <path d="M89 0H0V23H89V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask10_2_6)">
                        <path
                            d="M25.0792 20.1103V21.1718H26.1597V20.1103H26.7284V22.8821H26.1597V21.7026H25.0792V22.8821H24.4537V20.1103H25.0792Z"
                            fill="#CFA477"
                        />
                    </g>
                    <mask
                        id="mask11_2_6"
                        style={{ maskType: 'luminance' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="89"
                        height="23"
                    >
                        <path d="M89 0H0V23H89V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask11_2_6)">
                        <path
                            d="M29.97 21.8205L29.6287 20.759L29.2307 21.8205H29.97ZM29.9131 20.1103L30.9367 22.941H30.3112L30.1406 22.2923H29.1169L28.8894 22.941H28.2639L29.2875 20.1103H29.9131Z"
                            fill="#CFA477"
                        />
                    </g>
                    <mask
                        id="mask12_2_6"
                        style={{ maskType: 'luminance' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="89"
                        height="23"
                    >
                        <path d="M89 0H0V23H89V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask12_2_6)">
                        <path
                            d="M33.7233 21.3487C33.8371 21.3487 33.9508 21.2897 34.0077 21.2308C34.1214 21.2308 34.1214 21.1128 34.1214 20.9359C34.1214 20.818 34.0645 20.7 34.0077 20.641C33.9508 20.5821 33.8371 20.5231 33.7233 20.5231H33.0409V21.2897H33.7233V21.3487ZM33.9508 20.1103C34.0645 20.1103 34.1783 20.1103 34.292 20.1692C34.4057 20.2282 34.4626 20.2872 34.5195 20.3462C34.5764 20.4051 34.6332 20.5231 34.6901 20.5821C34.747 20.7 34.747 20.759 34.747 20.8769C34.747 21.0539 34.6901 21.1718 34.6332 21.2897C34.5764 21.4077 34.4626 21.5256 34.292 21.5846C34.3489 21.5846 34.4057 21.6436 34.4626 21.7026C34.5195 21.7615 34.5764 21.8205 34.5764 21.8795C34.6332 21.9385 34.6332 21.9974 34.6332 22.0564C34.6332 22.1154 34.6332 22.1744 34.6332 22.2923C34.6332 22.3513 34.6332 22.4103 34.6332 22.4692C34.6332 22.5282 34.6332 22.5872 34.6332 22.6462C34.6332 22.7051 34.6332 22.7641 34.6901 22.8231C34.6901 22.8821 34.747 22.941 34.747 22.941H34.1214C34.0645 22.8231 34.0645 22.7641 34.0645 22.6462C34.0645 22.5282 34.0645 22.4103 34.0077 22.2923C34.0077 22.1154 33.9508 22.0564 33.8939 21.9974C33.9508 21.8205 33.8371 21.8205 33.6664 21.8205H33.0409V22.941H32.4722V20.1103H33.9508Z"
                            fill="#CFA477"
                        />
                    </g>
                    <mask
                        id="mask13_2_6"
                        style={{ maskType: 'luminance' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="89"
                        height="23"
                    >
                        <path d="M89 0H0V23H89V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask13_2_6)">
                        <path
                            d="M37.2492 20.1103H36.6805V22.941H37.2492V20.1103Z"
                            fill="#CFA477"
                        />
                    </g>
                    <mask
                        id="mask14_2_6"
                        style={{ maskType: 'luminance' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="89"
                        height="23"
                    >
                        <path d="M89 0H0V23H89V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask14_2_6)">
                        <path
                            d="M38.8984 20.5821V20.1103H41.1163V20.5821H40.2633V22.8821H39.6946V20.5821H38.8984Z"
                            fill="#CFA477"
                        />
                    </g>
                    <mask
                        id="mask15_2_6"
                        style={{ maskType: 'luminance' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="89"
                        height="23"
                    >
                        <path d="M89 0H0V23H89V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask15_2_6)">
                        <path
                            d="M43.7323 21.8205L43.3911 20.759L43.0498 21.8205H43.7323ZM43.7323 20.1102L44.7559 22.941H44.1304L43.9029 22.2923H42.8792L42.6518 22.882H42.0831L43.1067 20.0513H43.7323V20.1102Z"
                            fill="#CFA477"
                        />
                    </g>
                    <mask
                        id="mask16_2_6"
                        style={{ maskType: 'luminance' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="89"
                        height="23"
                    >
                        <path d="M89 0H0V23H89V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask16_2_6)">
                        <path
                            d="M47.4856 22.4103C47.5425 22.4103 47.5994 22.4103 47.6562 22.4103C47.7131 22.4103 47.77 22.3513 47.77 22.3513C47.8268 22.3513 47.8268 22.2923 47.8837 22.2333C47.8837 22.1744 47.9406 22.1154 47.9406 22.0564C47.9406 21.9385 47.8837 21.8205 47.8268 21.7615C47.77 21.7026 47.6562 21.6436 47.5425 21.6436H46.9169V22.4103H47.4856ZM47.4288 21.2308C47.5425 21.2308 47.5994 21.2308 47.7131 21.1718C47.77 21.1128 47.8268 21.0539 47.8268 20.9359C47.8268 20.8769 47.8268 20.818 47.77 20.759C47.77 20.7 47.7131 20.7 47.6562 20.641C47.5994 20.641 47.5994 20.5821 47.5425 20.5821C47.4856 20.5821 47.4288 20.5821 47.3719 20.5821H46.8032V21.2308H47.4288ZM47.5425 20.1103C47.6562 20.1103 47.77 20.1103 47.8837 20.1692C47.9974 20.1692 48.0543 20.2282 48.1681 20.2872C48.2249 20.3462 48.2818 20.4051 48.3387 20.5231C48.3955 20.641 48.3955 20.7 48.3955 20.8769C48.3955 20.9949 48.3387 21.1128 48.2818 21.2308C48.2249 21.3487 48.1112 21.4077 47.9975 21.4667C48.1681 21.5256 48.2818 21.5846 48.3955 21.7026C48.4524 21.8205 48.5093 21.9974 48.5093 22.1744C48.5093 22.2923 48.5093 22.4103 48.4524 22.5282C48.3955 22.6462 48.3387 22.7051 48.2249 22.7641C48.1112 22.8231 48.0543 22.8821 47.9406 22.8821C47.8268 22.941 47.7131 22.941 47.5994 22.941H46.2914V20.1103H47.5425Z"
                            fill="#CFA477"
                        />
                    </g>
                    <mask
                        id="mask17_2_6"
                        style={{ maskType: 'luminance' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="89"
                        height="23"
                    >
                        <path d="M89 0H0V23H89V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask17_2_6)">
                        <path
                            d="M50.8409 20.1103V22.4103H52.1489V22.8821H50.2153V20.1103H50.8409Z"
                            fill="#CFA477"
                        />
                    </g>
                    <mask
                        id="mask18_2_6"
                        style={{ maskType: 'luminance' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="89"
                        height="23"
                    >
                        <path d="M89 0H0V23H89V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask18_2_6)">
                        <path
                            d="M55.7885 20.1103V20.5821H54.3668V21.2308H55.6748V21.7026H54.3668V22.4103H55.8454V22.8821H53.7981V20.1103H55.7885Z"
                            fill="#CFA477"
                        />
                    </g>
                </g>
            </g>
            <defs>
                <clipPath id="clip0_2_6">
                    <rect width="89" height="23" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default PledgerIcon;
